import {commonConfig, tlcConfig} from "@/config/common";
import {checkTlcPwd} from "@/tools/utils";

// 视频会议类型
const tlcTypes = {
  created: "created",
  related: "related",
};

export default {
  computed: {
    // 仅预约云会议
    onlyReserveTlc() {
      return this.$route.name === "front.tlc.reserve"
        || this.$route.name === "admin.reserveCloudMeeting"
    },
    // 锁定视频、直播会议不能修改
    lockTlc() {
      return this.isInMeeting || this.isOrganizeMeetings
    },
    tlcOnlyRelated() {
      return this.dataProxy.teleconferenceType === tlcTypes.related
    },
    mDocManufacturer() {
      if (this.lockTlc) {
        const tlcInfo = this.cMDoc.teleconferenceInfo || {};
        if (tlcInfo.conferenceNum) {
          return tlcInfo.manufacturer
        }
      }
    },
    tlcManufacturer() {
      if (this.mDocManufacturer) return this.mDocManufacturer;
      // console.log(this.sysTlcMFs);
      if (this.sysTlcMFs.length === 1) return this.sysTlcMFs[0];
      if (this.teleconferenceMF && this.teleconferenceMF !== tlcTypes.related) return this.teleconferenceMF
    },
    isCustomTlc() {
      return this.teleconferenceMF === tlcConfig.manufacturers.customTlc
    },
    waitingRoomKey() {
      return tlcConfig.waitingRoomKeyMap[this.tlcManufacturer]
    },
    hasCtrlPwd() {
      return tlcConfig.hasCtrlPwd[this.tlcManufacturer] || false;
    },
    dftTlcSettings() {
      return tlcConfig.dftSetting[this.tlcManufacturer] || {};
    },
    tlcSettingInfo() {
      const infoMap = tlcConfig.settingLabel[this.tlcManufacturer] || {};
      return Object.keys(infoMap).map(k => ({
        label: infoMap[k],
        value: k
      }))
    },
    tlcSecurityNotice() {
      if (this.dataProxy.teleconferenceType === tlcTypes.created
        && this.tlcManufacturer === tlcConfig.manufacturers.zoom) {
        if (!this.setTlcPwd && !this.dataProxy.teleconferenceInfo.settings.waiting_room) {
          return "必须选择一项或两项皆选"
        }
      }
    },
    curLvcManufacturer() {
      if (this.tlcManufacturer) {
        const tlcRLvcMF = tlcConfig.liveConferenceMF[this.tlcManufacturer];
        if (this.sysLvcManufacturer === tlcRLvcMF) return tlcRLvcMF
      }
    },
  },
  watch: {
    hasTeleconference: function (val) {
      if (val) {
        this.dataProxy.teleconferenceType = this.cMDoc && this.cMDoc.teleconferenceType || tlcTypes.created;
        if (!this.teleconferenceMF) {
          const tlcInfo = this.cMDoc && this.cMDoc.teleconferenceInfo || {};
          this.teleconferenceMF = tlcInfo.manufacturer || this.sysTlcMFs[0] || "";
        }
      } else {
        this.dataProxy.teleconferenceType = ""
      }
    },
    // 视频会议厂家
    teleconferenceMF: function (val) {
      // console.log("teleconferenceMF", val)
      if (this.isOrganizeMeetings) return;
      if (val === tlcTypes.related) {
        this.dataProxy.teleconferenceInfo.settings = {};
        this.dataProxy.teleconferenceType = val
      } else if (this.dataProxy.teleconferenceType === tlcTypes.created) {
        this.dataProxy.teleconferenceInfo.settings = {...this.dftTlcSettings}
      } else if (!this.mid) {
        this.dataProxy.teleconferenceType = tlcTypes.created
      }
      if (val === tlcConfig.manufacturers.customTlc) {
        this.setTlcPwd = false
      } else if (!this.waitingRoomKey) {
        this.setTlcPwd = true
      }
    },
  },
  methods: {
    changeTlcInfoByType(newVal, oldVal) {
      // console.log('change teleconferenceType:', {newVal, oldVal});
      if (!this.dataSource.chosenRoom.roomId && !this.isOrganizeMeetings) {
        if (newVal === tlcTypes.related) {
          this.dataProxy.teleconferenceType = tlcTypes.created;
          // vtToast(`请选择${this.sysFormTitles.meetingRoom}！`);
          return
        }
        if (oldVal && newVal === tlcTypes.created) return;
      }
      if (this.cMDoc && this.cMDoc.teleconferenceType === newVal) {
        const tlcInfo = this.cMDoc.teleconferenceInfo || {};
        this.dataProxy.teleconferenceInfo = {
          conferenceNum: this.newMtBasedOnStore ? null : tlcInfo.conferenceNum,
          password: this.mid ? tlcInfo.password : this.randomPwd.join,
          conferenceCtrlPwd: this.mid ? tlcInfo.conferenceCtrlPwd : this.randomPwd.control,
          desc: tlcInfo.desc,
          joinUrl: tlcInfo.joinUrl,
          settings: window._.mapObject(this.dftTlcSettings, (val, key) => (tlcInfo.settings || {})[key]),
        };
        // console.log(this.dataProxy.teleconferenceInfo)
        this.setTlcPwd = tlcInfo.password && newVal === tlcTypes.created;
      } else if (!this.isOrganizeMeetings) {
        // 清除记录
        const isCreated = newVal === tlcTypes.created;
        this.dataProxy.teleconferenceInfo = {
          conferenceNum: "",
          password: isCreated ? this.randomPwd.join : "",
          conferenceCtrlPwd: isCreated ? this.randomPwd.control : "",
          desc: "",
          settings: isCreated ? {...this.dftTlcSettings} : {},
        };
        this.setTlcPwd = isCreated && !this.isCustomTlc;
      }
    },
    checkConference() {
      const {
        teleconferenceType: tlcType, teleconferenceInfo: tlcInfo,
        enableLiveConference, liveConferenceInfo: lvcInfo,
      } = this.dataProxy;
      if (this.hasTeleconference && tlcInfo) {
        if (tlcType === tlcTypes.related && !tlcInfo.conferenceNum) {
          return "请填写会议号码";
        }
        if (this.tlcSecurityNotice) {
          return "安全设置：" + this.tlcSecurityNotice;
        }
        if (tlcType === tlcTypes.created) {
          const pwdNtcMsg = tlcConfig.pwdCheckReg[this.tlcManufacturer] && tlcConfig.pwdCheckReg[this.tlcManufacturer].msg || '';
          // 校验会议密码
          if (this.setTlcPwd) {
            if (!tlcInfo.password) return "请设置会议密码";
            if (!checkTlcPwd(this.tlcManufacturer, tlcInfo.password)
              && !commonConfig.asteriskReg.test(tlcInfo.password)) {
              return `会议${pwdNtcMsg || '密码至少为6位数字！'}`
            }
            tlcInfo.password += ""
          } else {
            tlcInfo.password = ""
          }
          // 校验主持人密码
          if (this.hasCtrlPwd) {
            if (!tlcInfo.conferenceCtrlPwd) return "请设置主持人密码";
            if (!checkTlcPwd(this.tlcManufacturer, tlcInfo.conferenceCtrlPwd)
              && !commonConfig.asteriskReg.test(tlcInfo.conferenceCtrlPwd)) {
              return `主持人${pwdNtcMsg || '密码至少为6位数字'}`
            }
            tlcInfo.conferenceCtrlPwd += ""
          } else {
            tlcInfo.conferenceCtrlPwd = ""
          }
          tlcInfo.manufacturer = this.tlcManufacturer
        } else if (this.isOrganizeMeetings) {
          tlcInfo.manufacturer = this.tlcManufacturer
        }
        // // 数值处理
        // tlcInfo.conferenceNum = Number(tlcInfo.conferenceNum);
        // if (Number.isNaN(tlcInfo.conferenceNum)) {
        //   tlcInfo.conferenceNum = null
        // }

        // 校验直播会议
        if (enableLiveConference && this.curLvcManufacturer) {
          if (!lvcInfo.external) {
            lvcInfo.password = ""
          }
          if (lvcInfo.password
            && !commonConfig.frLenNumReg.test(lvcInfo.password)
            && !commonConfig.asteriskReg.test(lvcInfo.password)) {
            return '直播密码为4位数字'
          }
          lvcInfo.manufacturer = this.sysLvcManufacturer
        } else {
          this.dataProxy.enableLiveConference = false;
          this.dataProxy.liveConferenceInfo = {}
        }
      } else {
        this.dataProxy.teleconferenceType = "";
        this.dataProxy.teleconferenceInfo = {settings: {}};
        // 未预约视频会议，去掉直播
        this.dataProxy.enableLiveConference = false;
        this.dataProxy.liveConferenceInfo = {}
      }
      if (this.mid && this.dataProxy.teleconferenceType) {
        commonConfig.asteriskReg.test(tlcInfo.password) && delete tlcInfo.password;
        commonConfig.asteriskReg.test(tlcInfo.conferenceCtrlPwd) && delete tlcInfo.conferenceCtrlPwd;
        commonConfig.asteriskReg.test(tlcInfo.joinUrl) && delete tlcInfo.joinUrl;
        commonConfig.asteriskReg.test(lvcInfo.password) && delete lvcInfo.password;
        commonConfig.asteriskReg.test(lvcInfo.hostKey) && delete lvcInfo.hostKey;
      }
    },
  },
}
